import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@/contexts/KeycloakContext';

export function Login() {
  const { authenticated, login } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated) {
      navigate('/', { replace: true });
    }
  }, [authenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-worm-950">
      <div className="w-full max-w-sm text-center">
        {/* Logo */}
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-gradient-to-br from-accent-primary to-accent-secondary flex items-center justify-center">
          <span className="text-4xl">◎</span>
        </div>

        <h1 className="text-3xl font-bold gradient-text mb-2">WholeWorm</h1>
        <p className="text-white/60 mb-8 text-balance">
          Bending the productivity space-time continuum
        </p>

        <button
          onClick={() => login()}
          className="btn-primary w-full mb-4"
        >
          Sign in with EvoTechnica
        </button>

        <p className="text-white/40 text-sm">
          For ADHD and autistic adults managing complex lives
        </p>
      </div>
    </div>
  );
}
